<template>
  <div v-loading="loading" class="ranking-layout" element-loading-text="加载中...">
    <div class="ranking-main">
      <div class="ranking-body">
        <table v-if="rows.length" class="ranking-table">
          <colgroup>
            <col style="width: 175px" />
            <col style="width: 257px" />
            <col style="width: 269px" />
            <col style="width: 166px" />
            <col />
          </colgroup>
          <tbody>
            <tr v-for="(row, index) in rows" :key="row.id" class="ranking-row"
              :class="{ 'ranking-row-intro': index === 0 }">
              <td v-if="index === 0" class="cell cell-rank cell-rank-intro" rowspan="2">
                <div class="title">律师排序</div>
                <div class="desc">律师向平台报备曾代理案件总数从大到小排序；数量相同时，按报备时间早晚排序</div>
              </td>
              <td v-else-if="index > 1" class="cell cell-rank">{{ index - 1 }}</td>
              <td class="cell cell-name">
                <el-image :src="row.photo" fit="cover" class="photo" v-if="row.photo" />
                <div class="name">{{ row.name }}</div>
              </td>
              <td class="cell cell-score">
                <div v-html="row.score"></div>
              </td>
              <td class="cell cell-case">
                <div v-html="row.specialties"></div>
              </td>
              <td class="cell cell-guide">
                <div v-html="row.guides"></div>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!loading && !rows.length" class="empty">暂无排行数据</div>
      </div>

      <div v-if="total > 0" class="pagination-wrap">
        <el-pagination class="ranking-pagination" background layout="total, sizes, prev, pager, next"
          :current-page="page_number" :page-size="page_num" :page-sizes="[10, 20, 30, 50]" :total="total"
          @current-change="handleCurrentChange" @size-change="handleSizeChange" />
      </div>
    </div>
  </div>
</template>

<script>
function stripHtmlTags(text) {
  return String(text || "")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim();
}

export default {
  name: "RankingBoard",
  data() {
    return {
      loading: false,
      page_number: 1,
      page_num: 10,
      total: 0,
      rows: [],
    };
  },
  created() {
    this.fetchRows();
  },
  methods: {
    normalizeField(value) {
      return String(value || "")
        .replace(/[`'"]/g, "")
        .trim();
    },
    mapLawyerRankingRow(item, index) {
      const pageNumber = Number(this.page_number || 1);
      const pageSize = Number(this.page_num || 10);
      const rank = (pageNumber - 1) * pageSize + index + 1;

      return {
        id: item.id || `lawyer-${rank}`,
        rank: String(rank),
        name: stripHtmlTags(item.name) || `律师${rank}`,
        photo: this.normalizeField(item.avatar) || '',
        score: item.score || "暂未提供",
        specialties: item.caseTypes || "暂未提供",
        guides: item.buyType || "",
      };
    },
    async fetchRows() {
      this.loading = true;

      try {
        const res = await this.$api({
          url: "Lawyer",
          method: "get",
          data: {
            keyword: "",
            caseTypes: "",
            page_number: this.page_number,
            page_num: this.page_num,
          },
        });

        if (res.code !== 200 || !res.data) {
          this.rows = [];
          this.total = 0;
          this.$message.error(res.msg || "律师排行获取失败");
          return;
        }

        const list = Array.isArray(res.data.list) ? res.data.list : [];

        this.rows = list.map((item, index) =>
          this.mapLawyerRankingRow(item, index),
        );
        this.total = Number(res.data.total || 0);
        this.page_num = Number(res.data.per_page || this.page_num || 10);
        this.page_number = Number(
          res.data.current_page || this.page_number || 1,
        );
      } catch (error) {
        this.rows = [];
        this.total = 0;
        this.$message.error("律师排行获取失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(page) {
      if (page === this.page_number) {
        return;
      }

      this.page_number = page;
      this.fetchRows();
    },
    handleSizeChange(size) {
      if (size === this.page_num) {
        return;
      }

      this.page_number = 1;
      this.page_num = size;
      this.fetchRows();
    },
  },
};
</script>

<style scoped>
.ranking-layout {
  width: 1190px;
  margin-top: 30px;
}

.ranking-body {
  border-top: 1px solid #a7a7a7;
  border-left: 1px solid #a7a7a7;
  border-right: 1px solid #a7a7a7;
  height: auto;
  overflow: visible;
}

.ranking-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 205px;
  color: #999999;
  font-size: 18px;
  line-height: 22px;
}

.ranking-table td {
  box-sizing: border-box;
  padding: 12px;
  border-right: 1px solid #a7a7a7;
  border-bottom: 1px solid #a7a7a7;
  color: #1d1d1d;
  text-align: left;
  vertical-align: middle;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  font-size: 18px;
  font-weight: 400;
  word-break: break-word;
}

.ranking-table td:last-child {
  border-right: 0;
}

/* Merge row 0 and row 1: remove border AND padding gap between them so the
   rowspan intro cell visually spans both rows with no seam. */
.ranking-row-intro td:not(.cell-rank-intro) {
  border-bottom: 0;
  padding-bottom: 0 !important;
}

.ranking-row-intro+.ranking-row td:not(.cell-rank-intro) {
  padding-top: 0 !important;
}

.ranking-row-intro td > div > :first-child,
.ranking-row-intro + .ranking-row td > div > :first-child {
  margin-top: 0;
}

.ranking-row-intro td > div > :last-child,
.ranking-row-intro + .ranking-row td > div > :last-child {
  margin-bottom: 0;
}

.title {
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
}

.desc {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 20px;
  text-indent: 2em;
  text-align: left;
}

.ranking-table .cell-rank {
  text-align: center;
}

.ranking-table .cell-rank-intro {
  vertical-align: top;
  padding: 12px 14px 0;
  text-align: center;
}

.ranking-table .cell-name {
  text-align: center;
}

.photo {
  display: block;
  margin: 0 auto;
  width: 97px;
  height: 140px;
  border-radius: 6px;
  overflow: hidden;
}

.name {
  margin-top: 12px;
  line-height: 22px;
}

.ranking-table .cell-score>div,
.ranking-table .cell-case>div,
.ranking-table .cell-guide>div {
  max-width: 100%;
}

.ranking-table .cell-score>div /deep/ p,
.ranking-table .cell-case>div /deep/ p {
  margin: 6px 0;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 20px 24px;
  background: #ffffff;
}

.pagination-wrap /deep/ .el-pagination {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  color: #666666;
  font-size: 16px;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.pagination-wrap /deep/ .el-pagination>* {
  float: none !important;
}

.pagination-wrap /deep/ .el-pagination__total,
.pagination-wrap /deep/ .el-pagination__jump,
.pagination-wrap /deep/ .el-pagination__sizes,
.pagination-wrap /deep/ .btn-prev,
.pagination-wrap /deep/ .btn-next,
.pagination-wrap /deep/ .el-pager {
  display: inline-flex;
  align-items: center;
  margin: 0 !important;
}

.pagination-wrap /deep/ .el-pagination__total,
.pagination-wrap /deep/ .el-pagination__jump,
.pagination-wrap /deep/ .el-pagination__sizes {
  color: #666666;
  font-size: 16px;
}

.pagination-wrap /deep/ .el-pagination__sizes .el-input,
.pagination-wrap /deep/ .el-pagination__jump .el-input {
  margin: 0;
}

.pagination-wrap /deep/ .el-input__inner {
  height: 36px;
  border: 1px solid #d9b6b2;
  border-radius: 4px;
  background: #ffffff;
  color: #333333;
}

.pagination-wrap /deep/ .el-input .el-select__caret {
  color: #d92f24;
}

.pagination-wrap /deep/ .btn-prev,
.pagination-wrap /deep/ .btn-next,
.pagination-wrap /deep/ .el-pager li {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  line-height: 1;
  margin: 0;
  border: 1px solid #e4b7b2;
  border-radius: 4px;
  background: #ffffff !important;
  color: #d92f24;
  font-weight: 500;
}

.pagination-wrap /deep/ .btn-prev i,
.pagination-wrap /deep/ .btn-next i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
}

.pagination-wrap /deep/ .btn-prev:hover,
.pagination-wrap /deep/ .btn-next:hover,
.pagination-wrap /deep/ .el-pager li:hover {
  border-color: #d92f24;
  color: #d92f24;
}

.pagination-wrap /deep/ .el-pager li.active {
  border-color: #d92f24;
  background: #d92f24 !important;
  color: #ffffff !important;
}

.pagination-wrap /deep/ .btn-prev:disabled,
.pagination-wrap /deep/ .btn-next:disabled {
  border-color: #ead6d4;
  background: #fff8f7 !important;
  color: #c9a7a3;
}

.pagination-wrap /deep/ .el-pagination.is-background .btn-prev,
.pagination-wrap /deep/ .el-pagination.is-background .btn-next,
.pagination-wrap /deep/ .el-pagination.is-background .el-pager li {
  box-shadow: none;
}
</style>
